import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import WhatIsThisModal from '@components/WhatIsThisModal';

import { getBullyingDefencePaths } from '@lib/paths';

import styles from './MagicMenu.module.scss';

interface MagicMenuProps {}

const MagicMenu: FC<MagicMenuProps> = () => {
  const [openWhatIsThis, setOpenWhatIsThis] = useState(false);
  const [biasUrls, setBiasUrls] = useState([]);
  const router = useRouter();

  const handleWhatIsThis = () => {
    setOpenWhatIsThis(!openWhatIsThis);
  };

  const handleSurpriseMe = () => {
    if (biasUrls.length === 0) return;

    const randomBias = biasUrls[Math.floor(Math.random() * biasUrls.length)];
    const biasParam = randomBias.params.bias;

    router.push(`/bullying-defence/${biasParam}`);
    localStorage.setItem('scratch', 'true');
  };

  const magicItems = [
    {
      emoji: '✨',
      name: 'Surprise me',
      onclick: () => {
        handleSurpriseMe();
      },
    },
    {
      emoji: '❓',
      name: 'What Is This?',
      onclick: () => {
        handleWhatIsThis();
      },
    },
  ];

  useEffect(() => {
    const getPaths = async () => {
      const paths = await getBullyingDefencePaths();
      setBiasUrls(paths);
    };

    getPaths();
  }, []);

  return (
    <>
      <div className={styles.magicMenu}>
        {magicItems.map((item, index) => {
          return (
            <div key={index}>
              <div onClick={item.onclick} className={styles.magicItem}>
                <span>
                  {item.emoji} {item.name}{' '}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      {openWhatIsThis && <WhatIsThisModal onClick={setOpenWhatIsThis} />}
    </>
  );
};

export default MagicMenu;
